import { KineticLines, Reveal } from "@/components/Reveal";

const PILLARS = [
  { no: "01", title: "REAL FRUIT", copy: "Fruit at its peak — never rushed, never faked." },
  { no: "02", title: "REAL MILK", copy: "Honest, creamy milk as the base of everything we churn." },
  { no: "03", title: "REAL INGREDIENTS", copy: "Ingredients you can picture. Nothing you need a dictionary for." },
];

export default function Philosophy() {
  return (
    <section className="bg-cream py-16 md:py-24" data-testid="philosophy-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <KineticLines
          lines={["REAL TASTES BETTER."]}
          className="block"
          lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-deep"
        />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-deep/70 md:text-lg">
            It is not a slogan. It is the standard every scoop is measured against.
          </p>
        </Reveal>

        <div className="mt-12 md:mt-16" data-testid="philosophy-pillars">
          {PILLARS.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.08}>
              <div className="group grid grid-cols-12 items-baseline gap-3 border-t border-cream-line py-7 transition-colors last:border-b hover:bg-white/60 md:gap-6 md:py-10">
                <span className="col-span-2 font-mono text-sm text-orange-rific md:col-span-1">{p.no}</span>
                <h3 className="col-span-10 font-display text-2xl font-semibold tracking-[-0.01em] text-deep transition-transform duration-300 group-hover:translate-x-2 md:col-span-5 md:text-4xl">
                  {p.title}
                </h3>
                <p className="col-span-10 col-start-3 font-body text-sm leading-relaxed text-deep/65 md:col-span-5 md:col-start-7 md:text-base">
                  {p.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
